<div class="pt-3 pb-3 text-center">
  <h4>Sponsored By</h4>
  <img class="img-fluid" src="{{ url }}" />
</div>
